module.exports = __webpack_public_path__ + "img/bitbox.3c28f39d.svg";